module.exports = __webpack_public_path__ + "img/apple-iphone-1.1349b2cc.png";